import { cn } from "../../lib/cn";
import { initials } from "../../lib/format";

export function Avatar({ name, size = 32, className }: { name: string; size?: number; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary to-glow text-white font-bold ring-2 ring-[var(--surface)]", className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
    >
      {initials(name)}
    </span>
  );
}
